export default function encodeFormData(formElement) {
  const data = new URLSearchParams()
  for (const pair of new FormData(formElement)) {
    data.append(pair[0], pair[1])
  }
  return data
}
